import { IAuthorizedInstallersFile } from '@authorizedInstaller/types/authorizedInstallers';
import { EMAIL_REGEX } from '@constants/common';
import { PHONE_REGEX } from '@constants/schema';
import * as Yup from 'yup';

const AuthorizedInstallerApplicationSchema = Yup.object({
    first_name: Yup.string().required('Required'),
    last_name: Yup.string().required('Required'),
    company_name: Yup.string().required('Required'),
    distributor: Yup.string().required('Required'),
    sales_manager: Yup.string().required('Required'),
    address1: Yup.string().required('Required'),
    city: Yup.string().required('Required'),
    country_code: Yup.string().required('Required'),
    state: Yup.string().optional(),
    mobile_phone: Yup.string().trim().matches(PHONE_REGEX, 'Invalid phone number'),
    email: Yup.string().trim().matches(EMAIL_REGEX, 'Invalid email').email('Invalid email').required('Required'),
    certificate_files: Yup.mixed<IAuthorizedInstallersFile[]>().optional(),
    installation_files: Yup.mixed<IAuthorizedInstallersFile[]>().optional(),
    accept_terms: Yup.boolean()
        .test('is-true', 'The terms & agreements must be accepted.', (value) => Boolean(value))
        .required('Required'),
});

export { AuthorizedInstallerApplicationSchema };
